// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Global font — Plus Jakarta Sans (matches design reference) ───────────── */

*, *::before, *::after {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;
  font-feature-settings: 'cv11', 'ss01';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
}

/* Apply Plus Jakarta Sans to EVERYTHING — overrides every inline fontFamily */
body,
body * {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
}

html, body, #root, .app-container {
  overflow-x: hidden !important;
  max-width: 100vw;
}

body {
  margin: 0;
  padding: 0;
  padding-bottom: env(safe-area-inset-bottom, 0px);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #161616;
  background: #ffffff;
  overflow-x: hidden !important;
  -webkit-overflow-scrolling: touch;
}

/* Flex item WebKit Safari fix: prevent overflow in flex/grid items */
div, section, main, article, header, footer {
  min-width: 0;
}

/* WebKit Form & Input Cross-Browser Enhancements */
input, textarea, select, button {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif !important;
  font-size: 16px; /* Prevents auto-zoom in iOS Safari on focus */
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0;
}

/* Disable scroll wheel value changes & spin buttons on number inputs */
input[type=number] {
  -moz-appearance: textfield;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Restore button click state in Safari */
button {
  cursor: pointer;
  background-color: transparent;
  border: none;
}

/* Standardized WebKit Backdrop Filter Utility */
.glass-panel {
  -webkit-backdrop-filter: blur(16px);
  backdrop-filter: blur(16px);
}

/* Nav links — weight 500, slightly off-white, exactly like screenshot */
nav a, nav button, [role="navigation"] a {
  font-weight: 500 !important;
  letter-spacing: 0.01em;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  margin: 0;
}

/* ── Animations for Sidebar & Mobile Overlays ── */
@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ── Responsive Table & Container Helpers ── */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1rem;
}

.table-responsive table {
  min-width: 600px;
}

/* Custom scrollbars for data tables on mobile */
.table-responsive::-webkit-scrollbar {
  height: 6px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #888;
}

/* Hide scrollbar when desired */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Utility to fix overflow on images and embeds */
img, video, iframe {
  max-width: 100%;
  height: auto;
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAGhF;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,gIAAgI;EAChI,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,8EAA8E;AAC9E;;EAEE,8GAA8G;AAChH;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,qEAAqE;AACrE;EACE,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,0FAA0F;EAC1F,eAAe,EAAE,8CAA8C;EAC/D,wBAAwB;EAExB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,0BAA0B;AAC5B;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,wEAAwE;AACxE;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA,mDAAmD;AACnD;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":["/* ── Global font — Plus Jakarta Sans (matches design reference) ───────────── */\n@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400&display=swap');\n\n*, *::before, *::after {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n}\n\nhtml {\n  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;\n  font-feature-settings: 'cv11', 'ss01';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  scroll-behavior: smooth;\n  -webkit-text-size-adjust: 100%;\n}\n\n/* Apply Plus Jakarta Sans to EVERYTHING — overrides every inline fontFamily */\nbody,\nbody * {\n  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;\n}\n\nhtml, body, #root, .app-container {\n  overflow-x: hidden !important;\n  max-width: 100vw;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #161616;\n  background: #ffffff;\n  overflow-x: hidden !important;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Flex item WebKit Safari fix: prevent overflow in flex/grid items */\ndiv, section, main, article, header, footer {\n  min-width: 0;\n}\n\n/* WebKit Form & Input Cross-Browser Enhancements */\ninput, textarea, select, button {\n  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif !important;\n  font-size: 16px; /* Prevents auto-zoom in iOS Safari on focus */\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border-radius: 0;\n}\n\n/* Disable scroll wheel value changes & spin buttons on number inputs */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Restore button click state in Safari */\nbutton {\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n}\n\n/* Standardized WebKit Backdrop Filter Utility */\n.glass-panel {\n  -webkit-backdrop-filter: blur(16px);\n  backdrop-filter: blur(16px);\n}\n\n/* Nav links — weight 500, slightly off-white, exactly like screenshot */\nnav a, nav button, [role=\"navigation\"] a {\n  font-weight: 500 !important;\n  letter-spacing: 0.01em;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  margin: 0;\n}\n\n/* ── Animations for Sidebar & Mobile Overlays ── */\n@keyframes slideInLeft {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* ── Responsive Table & Container Helpers ── */\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  margin-bottom: 1rem;\n}\n\n.table-responsive table {\n  min-width: 600px;\n}\n\n/* Custom scrollbars for data tables on mobile */\n.table-responsive::-webkit-scrollbar {\n  height: 6px;\n}\n\n.table-responsive::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.table-responsive::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n\n.table-responsive::-webkit-scrollbar-thumb:hover {\n  background: #888;\n}\n\n/* Hide scrollbar when desired */\n.no-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n.no-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n/* Utility to fix overflow on images and embeds */\nimg, video, iframe {\n  max-width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
